<template>
    <div class="app">
        <template v-if="action">

            <b-modal v-if="action.mode == 'modal'" :title="action.title" size="lg" visible ok-only button-size="sm">
                <div v-html="action.text"></div>
            </b-modal>

            <b-alert v-if="action.mode == 'alert'" show variant="light" dismissible
                     class="ads-alert text-white font-weight-bold text-center rounded-0 mb-0 bg-danger border-0">
                <b-container fluid>
                    <div v-html="action.text" class="ads-alert"></div>
                </b-container>
            </b-alert>
        </template>

        <Navbar/>

        <!--<div class="mb-3 mt-3 text-center" v-if="user.registered && user.subscribe_expired">
            <Adsense
                    data-ad-client="ca-pub-0972485314380963"
                    data-ad-slot="8061906316">
            </Adsense>
        </div>-->

        <div class="content" style="min-height: 50vh">
            <transition name="component-fade" mode="out-in">
                <router-view></router-view>
            </transition>
        </div>


        <div class="mb-3 text-center">
            <Adsense
                    data-ad-client="ca-pub-0972485314380963"
                    data-ad-slot="3548883450">
            </Adsense>
        </div>

        <Comments/>

        <Footer/>

        <notifications group="messages" classes="vue-notification" position="bottom right" width="350"/>

        <transition name="fade">
            <div class="wait" v-if="this.$store.state.wait.state">
                <div class="py-3 px-5 text-white shadow border-dark d-inline-block"
                     style="font-size: 12px; background-color: rgba(0,0,0,0.8)">
                    <b-spinner label="Spinning"></b-spinner>
                    <br>Пожалуйста, подождите...<br>{{ this.$store.state.wait.name }}
                </div>
            </div>
        </transition>

    </div>
</template>

<script>


import Navbar from "@/components/sites/parts/Navbar";
import Footer from "@/components/sites/parts/Footer";
//import Actions from "@/components/sites/parts/Actions";
import {mapGetters} from 'vuex';
import Comments from "@/components/base/Comments.vue";

export default {
    name: 'App',
    components: {
        Comments,
        Navbar,
        Footer

    },
    data: function () {
        return {
            action: false
        }
    },
    created: function () {
        this.Init()
        this.Actions()
    },
    methods: {
        Init: function () {
            // Инициализация всего и вся нахуй
            this.setOrgs();

            this.Enums('sums_primary', 'reg_salary_sums', 'Выберите тип начисления', true, false, true, '', 0);
            this.Enums('sums_secondary', 'reg_salary_sums', 'Выберите тип начисления', false, false, true, '', 0);
            this.Enums('deductions', 'reg_salary_deductions', 'Выберите тип удержания', false, false, true, '', 0);
            this.Enums('banks', 'reg_banks', 'Выберите банк', false, false, false, '', 0);


            //this.$store.commit('alert', [{title: 'Калькулятор готов', text: '111'}])


        },
        Messages: function (messages) {
            let type = 'info';
            let title = 'Информация';

            for (let i = 0; i < messages.length; i++) {
                switch (messages[i]['mode']) {
                    case 'success':
                        type = 'success';
                        title = 'Успешно'
                        break;

                    case 'warning':
                        type = 'warning';
                        title = 'Внимание'
                        break;

                    case 'error':
                        type = 'error';
                        title = 'Ошибка'

                }

                if (typeof messages[i]['title'] !== 'undefined' && messages[i]['title'] !== '') {
                    title = messages[i]['title'];
                }

                this.$notify({
                    type: type,
                    group: 'messages',
                    title: title,
                    text: messages[i]['text']

                });
            }
        },
      Actions: function () {
        this.$http
            .post(this.$apiold, {
              task: 'actions'
            })
            .then(response => {
              if (response.data.result) {
                this.action = response.data.result
              }
            })
      }
    },
    computed: {
        ...mapGetters(['notification', 'orgs', 'user'])
    },
    watch: {
        notification() {
            if (this.notification.length > 0) {
                this.Messages(this.notification);
                this.$store.commit('alert', []);
            }
        },
        orgs() {
            this.setWorkers();
        },
        user() {
            if (this.user.registered) {
                //this.setOrgs();
            }
        }
    }
}


</script>

<style scoped >
.ads-alert > a {
    color: #fff!important;
}
</style>